import { Mapper } from 'src/base/mapper'
import { DistrictTypeEntity } from 'src/data/entities/common.entity'
import { DistrictTypeModel } from 'src/domain/models/common.model'

export class DistrictMapper extends Mapper<DistrictTypeEntity, DistrictTypeModel> {
	mapFrom(param: DistrictTypeEntity): DistrictTypeModel {
		return this.resultData(param)
	}

	mapTo(param: DistrictTypeModel): DistrictTypeEntity {
		return this.resultData(param)
	}

	resultData(param: DistrictTypeEntity | DistrictTypeModel) {
		return {
			districtCode: param.districtCode,
			districtName: param.districtName,
		}
	}
}
